export default __webpack_public_path__ + "static/media/online-conversation.30e43cde.svg";